import React from "react";
import SmallHexagon from "./Common/SmallHexagon";

const SmallHexagonalLogo = () => {
  return (
    <div className="sm:pt-32">
      <div className="items-center flex flex-col">
        <div className="flex">
          <div className="relative" style={{ marginLeft: "26%", marginBottom: "-35%" }}>
            <SmallHexagon xPercent={"35%"} hexagonPath={"hexagonPath1"} text="Technology" textColor="rgba(255, 209, 26, 1)"/>
          </div>
          <div className="relative" style={{ marginLeft: "-33%", marginBottom: "-35%" }}>
            <SmallHexagon xPercent={"37%"} hexagonPath={"hexagonPath2"} text="Business" textColor="rgba(255, 209, 26, 1)"/>
          </div>
        </div>
        <div className="relative" style={{ marginLeft: "18%" }}>
          <SmallHexagon fontSize="28" fontWeight={600} hexagonPath={"hexagonPath3"} text="TechB" text2="softwares" color="rgba(230, 184, 0, 0.8)" textColor="black" background= "rgba(230, 184, 0, 0.5)"/>
        </div>
      </div>
    </div>
  );
};

export default SmallHexagonalLogo;
